"use client"

import Image from "next/image";
import LeadForm from "@/components/forms/LeadForm";
import { GroupedService } from "@/lib/services/services";

interface ContactSectionProps {
    lang?: string;
    title?: string;
    description?: string;
    image?: string | null;
    groupedServices?: GroupedService[];
    dict?: {
        form?: {
            name?: string;
            email?: string;
            phone?: string;
            send?: string;
            success?: string;
            error?: string;
            kvkk_consent?: string;
            marketing_consent?: string;
        };
    };
}

export default function ContactSection({ lang = "tr", title, description, image, dict }: ContactSectionProps) {
    return (
        <section className="bg-gray-50 py-16 lg:py-20" id="contact">
            <div className="container-custom">
                <div className="flex h-auto flex-col overflow-hidden rounded-3xl shadow-2xl lg:min-h-[600px] lg:flex-row">
                    <div className="flex w-full flex-col justify-center bg-[#051e3c] p-6 sm:p-8 lg:w-1/2 lg:p-12">
                        {title ? (
                            <h2 className="text-3xl font-bold tracking-[-0.03em] text-white md:text-[2.25rem] md:leading-[1.15]">
                                {title}
                            </h2>
                        ) : null}
                        {description ? (
                            <p className="mb-8 mt-4 max-w-[52ch] whitespace-pre-wrap text-[15px] leading-relaxed text-blue-100/80">
                                {description}
                            </p>
                        ) : null}

                        <LeadForm dict={dict} idPrefix="home-contact-form" lang={lang as "tr" | "en" | "ar"} />
                    </div>

                    {/* Mobilde gorsel alanin yuksekligi yoktu (gorunmuyordu); artik hic
                        render edilmez ve gorsel mobilde indirilmez. */}
                    <div className="relative hidden w-full bg-[#0a355c] lg:block lg:w-1/2">
                        {image ? (
                            <Image
                                src={image}
                                alt={title || "Cinik Polikliniği"}
                                fill
                                className="object-cover"
                                sizes="50vw"
                            />
                        ) : null}
                        <div className="absolute inset-0 bg-[#051e3c]/20" />
                    </div>
                </div>
            </div>
        </section>
    );
}
